export const isLocalImage = (image: string): boolean => {
  return (
    image.startsWith('data:') ||
    image.startsWith('blob:') ||
    image.startsWith('http://localhost')
  );
};

export const isContentfulImage = (image: string): boolean => {
  return image.includes('images.ctfassets.net');
};
